var map = {
	"./castle1.jpg": 6243,
	"./castle2.jpg": 5578,
	"./castle3.jpg": 2452,
	"./dungeon1.jpg": 7110,
	"./dungeon2.jpg": 8980,
	"./dungeon3.jpg": 8959,
	"./emblem.png": 4094,
	"./gates1.jpg": 5612,
	"./gates2.jpg": 8806,
	"./gates3.jpg": 1253,
	"./gates4.jpg": 3028,
	"./gates5.jpg": 4814,
	"./guard1-1.jpg": 3751,
	"./guard1-2.jpg": 7282,
	"./guard1-3.jpg": 9649,
	"./guard1-4.jpg": 415,
	"./guard1-5.jpg": 3439,
	"./guard2-1.jpg": 5835,
	"./guard2-2.jpg": 1577,
	"./guard2-3.jpg": 4484,
	"./guard2-4.jpg": 7566,
	"./guard2-5.jpg": 640,
	"./guard3-1.jpg": 3673,
	"./guard3-2.jpg": 6576,
	"./guard3-3.jpg": 9181,
	"./guard3-4.jpg": 9854,
	"./guard3-5.jpg": 8938,
	"./guard4-1.jpg": 947,
	"./guard4-2.jpg": 1494,
	"./guard4-3.jpg": 9949,
	"./guard4-4.jpg": 3936,
	"./guard4-5.jpg": 9196,
	"./guard5-1.jpg": 2964,
	"./guard5-2.jpg": 4369,
	"./guard5-3.jpg": 8361,
	"./guard5-4.jpg": 3665,
	"./guard5-5.jpg": 670,
	"./king1.jpg": 1241,
	"./king2.jpg": 7510,
	"./king3.jpg": 6617,
	"./letter1.jpg": 3116,
	"./pattern.jpg": 5217,
	"images/castle1.jpg": 6243,
	"images/castle2.jpg": 5578,
	"images/castle3.jpg": 2452,
	"images/dungeon1.jpg": 7110,
	"images/dungeon2.jpg": 8980,
	"images/dungeon3.jpg": 8959,
	"images/emblem.png": 4094,
	"images/gates1.jpg": 5612,
	"images/gates2.jpg": 8806,
	"images/gates3.jpg": 1253,
	"images/gates4.jpg": 3028,
	"images/gates5.jpg": 4814,
	"images/guard1-1.jpg": 3751,
	"images/guard1-2.jpg": 7282,
	"images/guard1-3.jpg": 9649,
	"images/guard1-4.jpg": 415,
	"images/guard1-5.jpg": 3439,
	"images/guard2-1.jpg": 5835,
	"images/guard2-2.jpg": 1577,
	"images/guard2-3.jpg": 4484,
	"images/guard2-4.jpg": 7566,
	"images/guard2-5.jpg": 640,
	"images/guard3-1.jpg": 3673,
	"images/guard3-2.jpg": 6576,
	"images/guard3-3.jpg": 9181,
	"images/guard3-4.jpg": 9854,
	"images/guard3-5.jpg": 8938,
	"images/guard4-1.jpg": 947,
	"images/guard4-2.jpg": 1494,
	"images/guard4-3.jpg": 9949,
	"images/guard4-4.jpg": 3936,
	"images/guard4-5.jpg": 9196,
	"images/guard5-1.jpg": 2964,
	"images/guard5-2.jpg": 4369,
	"images/guard5-3.jpg": 8361,
	"images/guard5-4.jpg": 3665,
	"images/guard5-5.jpg": 670,
	"images/king1.jpg": 1241,
	"images/king2.jpg": 7510,
	"images/king3.jpg": 6617,
	"images/letter1.jpg": 3116,
	"images/pattern.jpg": 5217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4480;